const $inject = [
  '$scope',
  '$q',
  'lodash',
  'dialogService',
  'moment',
  'Made',
  '$timeout',
  '$window',
  'employeeService',
  'BonusService',
  'administrationService',
  'customerService'
];
export default class BonusBikeleasingApproveController {
  constructor(
    $scope,
    $q,
    lodash,
    dialogService,
    moment,
    Made,
    $timeout,
    $window,
    employeeService,
    BonusService,
    administrationService,
    customerService
  ) {

    Object.assign(this, {
      $scope,
      $q,
      lodash,
      dialogService,
      moment,
      Made,
      $timeout,
      $window,
      employeeService,
      BonusService,
      administrationService,
      customerService
    });

    this.loading = true;
    this.employee_id = this.$scope.ngDialogData.employee_id;
    this.bonus_project_id = this.$scope.ngDialogData.bonus_project_id;
    this.bonus_id = this.$scope.ngDialogData.bonus_id;

    this.BonusService.getBikeleasingComponentForApproval(this.employee_id, this.bonus_project_id, this.bonus_id).then(
      (res) => {
        this.$timeout(() => {
          this.bikeleasing_component = res;
          this.loading = false;
        }, 0);
      }
    ).catch((err) => {
      console.error(err);
      this.bikeleasing_component = null;
    });

  }

  approveBikeleasingComponent() {
    this.loading = true;
    this.BonusService.boApproveBikeleasing(this.employee_id, this.bonus_project_id, this.bonus_id).then(
      (res) => {
        this.$scope.confirm();
      }).catch((err) => {
      console.error(err);
      this.$scope.closeThisDialog();
    });
  }

  close() {
    this.$scope.closeThisDialog();
  }
}
BonusBikeleasingApproveController.$inject = $inject;
